import CryptoJS from 'crypto-js';
import store from '@/store'
import Decimal from '@/utils/decimal';

const getToken = (len) => {
    len = len || 32;
    var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';    /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
    var maxPos = $chars.length;
    var returnStr = '';
    for (var i = 0; i < len; i++) {
        returnStr += $chars.charAt(Math.floor(Math.random() * maxPos));
    }
    // localStorage.setItem("token",returnStr)
    return returnStr;
};

//加密
const encrypt = (word, keyStr) => {
    // keyStr = keyStr ? keyStr : 'simplelin7q1q1q1';
    let key  = CryptoJS.enc.Utf8.parse(keyStr);//Latin1 w8m31+Yy/Nw6thPsMpO5fg==
    // let srcs = CryptoJS.enc.Utf8.parse(word);
    let encrypted = CryptoJS.DES.encrypt(word, key, {mode:CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7});
    return encrypted.toString();
};

//解密
const decrypt = (word, keyStr) => {
    keyStr = keyStr ? keyStr : 'simplelin7q1q1q1';
    let key  = CryptoJS.enc.Utf8.parse(keyStr);//Latin1 w8m31+Yy/Nw6thPsMpO5fg==
    let decrypt = CryptoJS.AES.decrypt(word, key, {mode:CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7});
    return CryptoJS.enc.Utf8.stringify(decrypt).toString();
};

const timeFormat = (value, format) => {
    let date = new Date(value);
    let y = date.getFullYear();
    let m = date.getMonth() + 1;
    let d = date.getDate();
    let h = date.getHours();
    let min = date.getMinutes();
    let s = date.getSeconds();
    let result = "";
    if (format == undefined) {
        result = `${y}-${m < 10 ? "0" + m : m}-${d < 10 ? "0" + d : d} ${
            h < 10 ? "0" + h : h
        }:${min < 10 ? "0" + min : min}:${s < 10 ? "0" + s : s}`;
    }
    if (format == "yyyy-MM-dd") {
        result = `${y}-${m < 10 ? "0" + m : m}-${d < 10 ? "0" + d : d}`;
    }
    if (format == "yyyy-MM-dd HH:mm:ss") {
        result = `${y}-${m < 10 ? "0" + m : m}-${d < 10 ? "0" + d : d} ${h < 10 ? "0" + h : h}:${min < 10 ? "0" + min : min}:${s < 10 ? "0" + s : s}`;
    }
    if (format == "yyyy-MM") {
        result = `${y}-${m < 10 ? "0" + m : m}`;
    }
    if (format == "mm-dd") {
        result = ` ${mm < 10 ? "0" + mm : mm}:${ddmin < 10 ? "0" + dd : dd}`;
    }
    if (format == "HH:mm") {
        result = ` ${h < 10 ? "0" + h : h}:${min < 10 ? "0" + min : min}`;
    }
    if (format == "yyyy") {
        result = `${y}`;
    }
    return result;
};

const cardHiding = (value) => {
    if (!value)
        return value;
    return value.replace(/^(.{6})(?:\w+)(.{4})$/, "\$1********\$2")
}

const isEmpty = (data) =>  {
    return data === null || data === undefined || data === ''
}

const isNotEmpty = (data) =>  {
    return data != null && data != undefined && data != ''
}

const isEmptyObjct = (data)  => {
    return isEmpty(data) || JSON.stringify(data) === '{}'
}

//保留小数位数
const getPrecisionData = (value,precision) =>   {
    if(precision==undefined || precision==null || precision==''){
        precision=2;
    }

    if(value==undefined || value==null || value==''){
        return 0.00;
    }else {
        var DN = Decimal.clone();
        if (precision < 0) {
            return value;
        } else {
            var value_new = DN(value).toNumber().toFixed(precision);
            return value_new;
        }
    }
}

//计算含税单价/
const getTaxPrice=(taxRate, price, precision)=> {
    if(precision==undefined || precision==null || precision==''){
        precision=2;
    }
    var DN = Decimal.clone();
    var value = DN(price).mul(DN(taxRate/100)).toNumber();
    let value_new = getPlusData(price, value, precision);
    return value_new;
}

//计算税前单价/
const getPrice=(taxRate, taxPrice, precision)=> {
    if(precision==undefined || precision==null || precision==''){
        precision=2;
    }
    var DN = Decimal.clone();
    var value = DN(DN(1).add(DN(taxRate/100))).toNumber();
    let value_new = getDividedByData(taxPrice, value, precision);
    return value_new;
}

//计算税额/
const getTax=(taxRate, total, precision)=> {
    if(precision==undefined || precision==null || precision==''){
        precision=2;
    }
    var DN = Decimal.clone();
    var value_new = DN(total).mul(DN(taxRate/100)).toNumber();
    if (precision < 0) {
        return value_new;
    } else {
        value_new = DN(value_new).toFixed(precision);
        return value_new;
    }
}


//计算乘积/
const getMultiplyData=(value1, value2, precision)=> {
    if(precision==undefined || precision==null || precision==''){
        precision=2;
    }
    var DN = Decimal.clone();
    var value_new = DN(value1).mul(DN(value2)).toNumber();
    if (precision < 0) {
        return value_new;
    } else {
        value_new = DN(value_new).toFixed(precision);
        return value_new;
    }
}

//计算和
const getPlusData=(value1, value2, precision)=> {
    if(precision==undefined || precision==null || precision==''){
        precision=2;
    }
    var DN = Decimal.clone();
    var value_new = DN(value1).add(DN(value2)).toNumber();
    if (precision < 0) {
        return value_new;
    } else {
        value_new = DN(value_new).toFixed(precision);
        return value_new;
    }
}

//计算差
const getMinusData=(value1, value2, precision)=> {
    if(precision==undefined || precision==null || precision==''){
        precision=2;
    }
    var DN = Decimal.clone();
    var value_new = DN(value1).sub(DN(value2)).toNumber();
    if (precision < 0) {
        return value_new;
    } else {
        value_new = DN(value_new).toFixed(precision);
        return value_new;
    }
}

//计算商
const getDividedByData=(value1, value2, precision)=> {
    if(precision==undefined || precision==null || precision==''){
        precision=2;
    }
    var DN = Decimal.clone();
    var value_new = DN(value1).div(DN(value2)).toNumber();
    if (precision < 0) {
        return value_new;
    } else {
        value_new = DN(value_new).toFixed(precision);
        return value_new;
    }
}

//计算账单总金额
const getBillTotal=(datalist, precision)=> {
    if(precision==undefined || precision==null || precision==''){
        precision=2;
    }
    let billTotal_total=0;
    for(let i=0;i<datalist.length;i++){
        let item = datalist[i];
        if(item.total!=undefined && item.total!=null && item.total != "" ) {
            billTotal_total=getPlusData(billTotal_total,item.total,precision);
        }
    }
    return  billTotal_total;
}

//计算账单总金额(含税)
const getTaxTotal=(datalist, precision)=> {
    if(precision==undefined || precision==null || precision==''){
        precision=2;
    }
    let taxTotal_total=0;
    for(let i=0;i<datalist.length;i++){
        let item = datalist[i];

        if(item.taxTotal!=undefined && item.taxTotal!=null && item.taxTotal != "" ) {
            taxTotal_total=getPlusData(taxTotal_total,item.taxTotal,precision);
        }
    }
    return  taxTotal_total;
}

//计算成本总金额(含税)
const getCostTotal=(datalist, precision)=> {
    if(precision==undefined || precision==null || precision==''){
        precision=2;
    }
    let costTotal_total=0;
    for(let i=0;i<datalist.length;i++){
        let item = datalist[i];

        if(item.costTotal!=undefined && item.costTotal!=null && item.costTotal != "" ) {
            costTotal_total=getPlusData(costTotal_total,item.profitTotal,precision);
        }
    }
    return  costTotal_total;
}

//计算账单总金额(含税)
const getProfitTotal=(datalist, precision)=> {
    if(precision==undefined || precision==null || precision==''){
        precision=2;
    }
    let profitTotal_total=0;
    for(let i=0;i<datalist.length;i++){
        let item = datalist[i];

        if(item.profitTotal!=undefined && item.profitTotal!=null && item.profitTotal != "" ) {
            profitTotal_total=getPlusData(profitTotal_total,item.profitTotal,precision);
        }
    }
    return  profitTotal_total;
}

//计算付款总金额
const getPayTotal=(datalist, precision)=> {
    if(precision==undefined || precision==null || precision==''){
        precision=2;
    }
    let payTotal_total=0;
    for(let i=0;i<datalist.length;i++){
        let item = datalist[i];

        if(item.payTotal!=undefined && item.payTotal!=null && item.payTotal != "" ) {
            payTotal_total=getPlusData(payTotal_total,item.payTotal,precision);
        }
    }
    return  payTotal_total;
}

//计算商
const openPostWindow=(para)=> {

    let url=para.url;
    let param=para.param;

    //首先创建一个form表单
    let tempForm = document.createElement("form");

    tempForm.id = "tempForm1";
    //制定发送请求的方式为post
    tempForm.method = "post";
    //此为window.open的url，通过表单的action来实现
    tempForm.action = window.host.ProjectUrl+url;


    for(var key in param){
        let hideInput = document.createElement("input");
        hideInput.type = "hidden";
        hideInput.name = key;
        hideInput.value = param[key];

        //将input表单放到form表单里
        tempForm.appendChild(hideInput);
    }


    //此为给form表单绑定事件（onsubmit），由于存在浏览器兼容问题所以此处加了一个判断。
    //但实质都是为form表单绑定一个提交事件，以便之后触发实现window.open效果
    if (document.all) {
        tempForm.attachEvent("onsubmit", function () {
        });        //IE
    } else {
        let subObj = tempForm.addEventListener("submit", function () {
        }, false);    //firefox
    }


    //将此form表单添加到页面主体body中
    document.body.appendChild(tempForm);

    //手动触发，提交表单
    tempForm.submit();


    //从body中移除form表单
    document.body.removeChild(tempForm);
}

//根据审核标识获取linkUrl
const getLinkUrlByModelKey=(model_key)=> {
    if(model_key.indexOf(":")>0){
        var arrKey=model_key.split(":");
        model_key=arrKey[0];
    }

    let linkUrl;
    let billType;
    switch (model_key) {

        case "KEY_ProjectIntoBill":
            linkUrl = "projectintobill";
            billType = "ProjectIntoBill";
            break;
        case "KEY_ProjectIntoRetBill":
            linkUrl = "projectintoretbill";
            billType = "ProjectIntoRetBill";
            break;
        case "KEY_ProjectOutBill":
            linkUrl = "projectoutbill";
            billType = "ProjectOutBill";
            break;
        case "KEY_ProjectOutRetBill":
            linkUrl = "projectoutretbill";
            billType = "ProjectOutRetBill";
            break;
        case "KEY_ProjectBorrowBill":
            linkUrl = "projectborrowbill";
            billType = "ProjectBorrowBill";
            break;
        case "KEY_ProjectBorrRetBill":
            linkUrl = "projectborrretbill";
            billType = "ProjectBorrRetBill";
            break;
        case "KEY_ProjectLendBill":
            linkUrl = "projectlendbill";
            billType = "ProjectLendBill";
            break;
        case "KEY_ProjectLendRetBill":
            linkUrl = "projectlendretbill";
            billType = "ProjectLendRetBill";
            break;
        case "KEY_ProjectTransferBill":
            linkUrl = "projecttransferbill";
            billType = "ProjectTransferBill";
            break;
        case "KEY_ProjectBreakageBill":
            linkUrl = "projectbreakagebill";
            billType = "ProjectBreakageBill";
            break;
        case "KEY_ProjectCheckBill":
            linkUrl = "projectcheckbill";
            billType = "ProjectCheckBill";
            break;

        case "KEY_PlanYear":
            linkUrl = "planyear";
            billType = "PlanYear";
            break;
        case "KEY_PlanQuarter":
            linkUrl = "planquarter";
            billType = "PlanQuarter";
            break;
        case "KEY_PlanMonth":
            linkUrl = "planmonth";
            billType = "PlanMonth";
            break;
        case "KEY_PlanTemp":
            linkUrl = "plantemp";
            billType = "PlanTemp";
            break;

        case "KEY_PlanPurchase":
            linkUrl = "planpurchase";
            billType = "PlanPurchase";
            break;
        case "KEY_PurchaseContract":
            linkUrl = "purchasecontract";
            billType = "PurchaseContract";
            break;
        case "KEY_SupplyOrder":
            linkUrl = "supplyorder";
            billType = "SupplyOrder";
            break;
        case "KEY_SupplyInspect":
            linkUrl = "supplyinspect";
            billType = "SupplyInspect";
            break;
        case "KEY_SupplyReturn":
            linkUrl = "supplyreturn";
            billType = "SupplyReturn";
            break;
        case "KEY_SupplyInto":
            linkUrl = "supplyinto";
            billType = "SupplyInto";
            break;
        case "KEY_SupplyIntoRet":
            linkUrl = "supplyintoret";
            billType = "SupplyIntoRet";
            break;
        case "KEY_PurchaseInvoice":
            linkUrl = "purchaseinvoice";
            billType = "PurchaseInvoice";
            break;
        case "KEY_ContractPay":
            linkUrl = "contractpay";
            billType = "ContractPay";
            break;
        case "KEY_ContractSettle":
            linkUrl = "contractsettle";
            billType = "ContractSettle";
            break;
        case "KEY_SporadicPurchase":
            linkUrl = "sporadicpurchase";
            billType = "SporadicPurchase";
            break;
        case "KEY_Reimburse":
            linkUrl = "reimburse";
            billType = "Reimburse";
            break;

        case "KEY_AssetsIntoBill":
            linkUrl = "assetsintobill";
            billType = "AssetsIntoBill";
            break;
        case "KEY_AssetsIntoRetBill":
            linkUrl = "assetsintoretbill";
            billType = "AssetsIntoRetBill";
            break;
        case "KEY_AssetsUsedBill":
            linkUrl = "assetsusedbill";
            billType = "AssetsUsedBill";
            break;
        case "KEY_AssetsUsedRetBill":
            linkUrl = "assetsusedretbill";
            billType = "AssetsUsedRetBill";
            break;
        case "KEY_AssetsLendBill":
            linkUrl = "assetslendbill";
            billType = "AssetsLendBill";
            break;
        case "KEY_AssetsLendRetBill":
            linkUrl = "assetslendretbill";
            billType = "AssetsLendRetBill";
            break;
        case "KEY_AssetsCheckBill":
            linkUrl = "assetscheckbill";
            billType = "AssetsCheckBill";
            break;
        case "KEY_AssetsBreakageBill":
            linkUrl = "assetsbreakagebill";
            billType = "AssetsBreakageBill";
            break;
        case "KEY_AssetsTransferBill":
            linkUrl = "assetstransferbill";
            billType = "AssetsTransferBill";
            break;
        case "KEY_AssetsRepair":
            linkUrl = "assetsrepair";
            billType = "AssetsRepair";
            break;
        case "KEY_AssetsMaintain":
            linkUrl = "assetsmaintain";
            billType = "AssetsMaintain";
            break;

        case "KEY_IntoBill":
            linkUrl = "intobill";
            billType = "IntoBill";
            break;
        case "KEY_IntoRetBill":
            linkUrl = "intoretbill";
            billType = "IntoRetBill";
            break;
        case "KEY_DirectBill":
            linkUrl = "directbill";
            billType = "DirectBill";
            break;
        case "KEY_OutBill":
            linkUrl = "outbill";
            billType = "OutBill";
            break;
        case "KEY_RequisitionBill":
            linkUrl = "requisitionbill";
            billType = "RequisitionBill";
            break;
        case "KEY_OutRetBill":
            linkUrl = "outretbill";
            billType = "OutRetBill";
            break;
        case "KEY_BorrowBill":
            linkUrl = "borrowbill";
            billType = "BorrowBill";
            break;
        case "KEY_BorrowRetBill":
            linkUrl = "borrretbill";
            billType = "ProjectIntoBill";
            break;
        case "KEY_LendBill":
            linkUrl = "lendbill";
            billType = "LendBill";
            break;
        case "KEY_LendRetBill":
            linkUrl = "lendretbill";
            billType = "LendRetBill";
            break;
        case "KEY_TransferBill":
            linkUrl = "transferbill";
            billType = "TransferBill";
            break;
        case "KEY_BreakageBill":
            linkUrl = "breakagebill";
            billType = "BreakageBill";
            break;
        case "KEY_CheckBill":
            linkUrl = "checkbill";
            billType = "CheckBill";
            break;

        case "KEY_ConsumIntoBill":
            linkUrl = "consumintobill";
            billType = "ConsumIntoBill";
            break;
        case "KEY_ConsumIntoRetBill":
            linkUrl = "consumintoretbill";
            billType = "ConsumIntoRetBill";
            break;
        case "KEY_ConsumUsedBill":
            linkUrl = "consumusedbill";
            billType = "ConsumUsedBill";
            break;
        case "KEY_ConsumUsedRetBill":
            linkUrl = "consumusedretbill";
            billType = "ConsumUsedRetBill";
            break;
        case "KEY_ConsumLendBill":
            linkUrl = "consumlendbill";
            billType = "ConsumLendBill";
            break;
        case "KEY_ConsumLendRetBill":
            linkUrl = "consumlendretbill";
            billType = "ConsumLendRetBill";
            break;
        case "KEY_ConsumCheckBill":
            linkUrl = "consumcheckbill";
            billType = "ConsumCheckBill";
            break;
        case "KEY_ConsumBreakageBill":
            linkUrl = "consumbreakagebill";
            billType = "ConsumBreakageBill";
            break;
        case "KEY_ConsumTransferBill":
            linkUrl = "consumtransferbill";
            billType = "ConsumTransferBill";
            break;
        case "KEY_ConsumRepair":
            linkUrl = "assetsrepair";
            billType = "ConsumRepair";
            break;
        case "KEY_ConsumMaintain":
            linkUrl = "assetsmaintain";
            billType = "ConsumMaintain";
            break;

        case "KEY_SaleContract":
            linkUrl = "salecontract";
            billType = "SaleContract";
            break;
        case "KEY_SaleOrder":
            linkUrl = "saleorder";
            billType = "SaleOrder";
            break;
        case "KEY_SaleDelivery":
            linkUrl = "saledelivery";
            billType = "SaleDelivery";
            break;
        case "KEY_SaleReturn":
            linkUrl = "salereturn";
            billType = "SaleReturn";
            break;
        case "KEY_SaleInvoice":
            linkUrl = "saleinvoice";
            billType = "SaleInvoice";
            break;

        case "KEY_FeeBill":
            linkUrl = "feebill";
            billType = "FeeBill";
            break;
        case "KEY_NonBusinessIn":
            linkUrl = "nonbusinessin";
            billType = "NonBusinessIn";
            break;
        case "KEY_NonBusinessPay":
            linkUrl = "nonbusinesspay";
            billType = "NonBusinessPay";
            break;
        case "KEY_PurchasePay":
            linkUrl = "purchasepay";
            billType = "PurchasePay";
            break;
        case "KEY_SaleCollection":
            linkUrl = "salecollection";
            billType = "SaleCollection";
            break;
        case "KEY_Voucher":
            linkUrl = "voucher";
            billType = "Voucher";
            break;
    }

    let returnInfo={
        linkUrl:linkUrl,
        billType:billType,
    }
    return returnInfo;
}

//获取最新设置信息
const getSystemOptions= async ()=>{
    let param = {
        url: "/systemoptions/getNewSystemOptions",
        param: {}
    }
    const data = await store.dispatch('pubMethod', param)
    let systemOptions = data.data;

    return systemOptions;
}

export default {
    timeFormat,
    cardHiding,
    getToken,
    encrypt,
    decrypt,
    isEmpty,
    isNotEmpty,
    isEmptyObjct,
    getPrecisionData,
    getTaxPrice,
    getPrice,
    getTax,
    getMultiplyData,
    getPlusData,
    getMinusData,
    getDividedByData,
    openPostWindow,
    getBillTotal,
    getTaxTotal,
    getCostTotal,
    getProfitTotal,
    getPayTotal,
    getLinkUrlByModelKey,
    getSystemOptions,
}